<div id="menu-profile-container">
    <nav (keyup.escape)="close()" aria-label="Profile Menu">
        <div id="account-settings-header">
            <deco-icon [iconClass]="'fa-regular fa-user'" [color]="'#fff'" [fontSize]="'18px'" />
            <p>{{ 'toolbar.profilePanel.header' | translate }}</p>
        </div>

        <ul id="menu-profile">
            @if (currentUser()?.isAdmin) {
                <li id="impersonate-item">
                    <button id="impersonate" (click)="setDisplayImpersonateModal(true)" autofocus>
                        <div class="btn-icon" id="impersonate-icon" aria-hidden="true">
                            <i class="fa-light fa-users-viewfinder"></i>
                        </div>
                        <label for="account-settings-icon" id="impersonate-label">{{
                            'profileMenu.impersonate' | translate
                        }}</label>
                    </button>
                </li>
            }
            <li id="account-settings-item">
                <a
                    tabindex="0"
                    id="account-settings-link"
                    aria-label="Go to Account Settings"
                    (click)="goToAccountSettings(); logAction('account-settings')"
                    (keyup.enter)="goToAccountSettings(); logAction('account-settings')">
                    <button id="account-settings" tabindex="-1">
                        <div class="item-container">
                            <div class="btn-icon" id="account-settings-icon" aria-hidden="true">
                                <deco-icon [iconClass]="'fa-light fa-user-gear'" [color]="'#000'" />
                            </div>
                            <label for="account-settings-icon" id="account-settings-label">{{
                                'profileMenu.accountSettings' | translate
                            }}</label>
                        </div>
                        <deco-icon
                            [iconClass]="'fa-regular fa-arrow-up-right-from-square'"
                            [color]="'#000'"></deco-icon>
                    </button>
                </a>
            </li>
            <li id="quickorder-settings-item">
                <a
                    tabindex="0"
                    id="quickorder-settings-link"
                    aria-label="Go to QuickOrder Settings"
                    (click)="goToQuickOrderSettings(); logAction('quickorder-settings')"
                    (keyup.enter)="goToQuickOrderSettings(); logAction('quickorder-settings')">
                    <button id="quickorder-settings" tabindex="-1">
                        <div class="btn-icon" id="quickorder-settings-icon" aria-hidden="true">
                            <deco-icon [iconClass]="'fa-light fa-file-invoice-dollar'" [color]="'#000'" />
                        </div>
                        <label for="billing-settings-icon" id="quickorder-settings-label">{{
                            'profileMenu.quickorderSettings' | translate
                        }}</label>
                    </button>
                </a>
            </li>
            <li id="billing-settings-item">
                <a
                    tabindex="0"
                    id="billing-settings-link"
                    aria-label="Go to Billing Settings"
                    (click)="goToBillingSettings(); logAction('billing-settings')"
                    (keyup.enter)="goToBillingSettings(); logAction('billing-settings')">
                    <button id="billing-settings" tabindex="-1">
                        <div class="btn-icon" id="billing-settings-icon" aria-hidden="true">
                            <deco-icon [iconClass]="'fa-light fa-file-invoice-dollar'" [color]="'#000'" />
                        </div>
                        <label for="billing-settings-icon" id="billing-settings-label">{{
                            'profileMenu.paymentSettings' | translate
                        }}</label>
                    </button>
                </a>
            </li>
            <li id="message-settings-item">
                <a
                    tabindex="0"
                    id="message-settings-link"
                    aria-label="Go to Message Settings"
                    (click)="goToMessageSettings(); logAction('message-settings')"
                    (keyup.enter)="goToMessageSettings(); logAction('message-settings')">
                    <button id="message-settings" tabindex="-1">
                        <div class="btn-icon" id="message-settings-icon" aria-hidden="true">
                            <deco-icon [iconClass]="'fa-light fa-message-lines'" [color]="'#000'" />
                        </div>
                        <label for="message-settings-icon" id="message-settings-label">{{
                            'profileMenu.messageSettings' | translate
                        }}</label>
                    </button>
                </a>
            </li>
            <li id="sign-out-item">
                <button
                    id="sign-out-link"
                    tabindex="0"
                    aria-label="Sign Out"
                    (click)="logout()"
                    (keyup.enter)="logout()">
                    <div class="btn-icon" id="sign-out-icon" aria-hidden="true">
                        <deco-icon [iconClass]="'fa-light fa-right-from-bracket'" [color]="'#000'" />
                    </div>
                    <label for="sign-out-icon" id="sign-out-label">{{ 'profileMenu.signOut' | translate }}</label>
                </button>
            </li>
        </ul>
    </nav>
</div>
